import Interview from './Interview'

export default function install(Vue) {
  Vue.component('quiz-interview-form', Interview)
}
